export type ColumnType =
  | 'code'
  | 'product'
  | 'productAndDescription'
  | 'price'
  | 'pricePerCase'
  | 'material'
  | 'packing'
  | 'dimensions'
  | 'package'
  | 'picture';

export interface CategoryColumn {
  name: string;
  type: ColumnType;
  cssClass: string;
}

export interface CategoryMetadata {
  category: string;
  columns: CategoryColumn[];
}

export const CATEGORY_METADATA: Record<string, CategoryMetadata> = {
  'KRAFT FOLDED TAKEOUT BOX': {
    category: 'KRAFT FOLDED TAKEOUT BOX',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'CLAMSHELL TAKE-OUT BOX': {
    category: 'CLAMSHELL TAKE-OUT BOX',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'KRAFT FOOD TRAY': {
    category: 'KRAFT FOOD TRAY',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'MINERAL POWDER CLAMSHELLS': {
    category: 'MINERAL POWDER CLAMSHELLS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'MINERAL POWDER PLATES': {
    category: 'MINERAL POWDER PLATES',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'BLACK PLASTIC CONTAINERS': {
    category: 'BLACK PLASTIC CONTAINERS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'BLACK SUSHI TRAYS': {
    category: 'BLACK SUSHI TRAYS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'DUAL COLOR BLACK CONTAINERS': {
    category: 'DUAL COLOR BLACK CONTAINERS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'DUAL COLOR BLACK/CLEAR CLAMSHELLS': {
    category: 'DUAL COLOR BLACK/CLEAR CLAMSHELLS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'CLEAR CLAMSHELL': {
    category: 'CLEAR CLAMSHELL',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'TRANSLUCID PP CLAMSHELL': {
    category: 'TRANSLUCID PP CLAMSHELL',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'TAMPER-EVIDENT HINGED CONTAINER': {
    category: 'TAMPER-EVIDENT HINGED CONTAINER',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PLASTIC DELI CONTAINER': {
    category: 'PLASTIC DELI CONTAINER',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER KRAFT CONTAINER': {
    category: 'PAPER KRAFT CONTAINER',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER FOOD CONTAINER/PAPER SOUP CUP': {
    category: 'PAPER FOOD CONTAINER/PAPER SOUP CUP',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PORTION/SOUFFLE CUPS': {
    category: 'PORTION/SOUFFLE CUPS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'CLEAR DRINKING CUPS AND LIDS': {
    category: 'CLEAR DRINKING CUPS AND LIDS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'CUTLERY': {
    category: 'CUTLERY',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'NAPKINS AND NAPKINS BANDS': {
    category: 'NAPKINS AND NAPKINS BANDS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'REGISTER ROLLS': {
    category: 'REGISTER ROLLS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'GLOVES': {
    category: 'GLOVES',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'STRAWS': {
    category: 'STRAWS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'COFFEE AND COCKTAIL STIRRERS': {
    category: 'COFFEE AND COCKTAIL STIRRERS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PLASTIC BAGS': {
    category: 'PLASTIC BAGS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'NON-HANDLE PAPER BAGS': {
    category: 'NON-HANDLE PAPER BAGS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER BAGS WITH HANDLE': {
    category: 'PAPER BAGS WITH HANDLE',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER CLEANING SUPPLIES': {
    category: 'PAPER CLEANING SUPPLIES',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product and Description', type: 'productAndDescription', cssClass: 'col-product-desc' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'CAN LINERS/TRASH BAGS': {
    category: 'CAN LINERS/TRASH BAGS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product and Description', type: 'productAndDescription', cssClass: 'col-product-desc' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER CUPS HOT DRINKS': {
    category: 'PAPER CUPS HOT DRINKS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Package', type: 'package', cssClass: 'col-package' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'PAPER FRENCH FRY CUPS': {
    category: 'PAPER FRENCH FRY CUPS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Package', type: 'package', cssClass: 'col-package' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'FOAM TAKEOUT CONTAINERS': {
    category: 'FOAM TAKEOUT CONTAINERS',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product', type: 'product', cssClass: 'col-product' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Material', type: 'material', cssClass: 'col-material' },
      { name: 'Packing', type: 'packing', cssClass: 'col-packing' },
      { name: 'Product Dim:', type: 'dimensions', cssClass: 'col-dims' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'SCRUBBERS AND SPONGES': {
    category: 'SCRUBBERS AND SPONGES',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product and Description', type: 'productAndDescription', cssClass: 'col-product-desc' },
      { name: 'Price per Case', type: 'pricePerCase', cssClass: 'col-price' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
  'WAREHOUSE SUPPLIES': {
    category: 'WAREHOUSE SUPPLIES',
    columns: [
      { name: 'Code', type: 'code', cssClass: 'col-code' },
      { name: 'Product and Description', type: 'productAndDescription', cssClass: 'col-product-desc' },
      { name: 'Price', type: 'price', cssClass: 'col-price' },
      { name: 'Picture', type: 'picture', cssClass: 'col-picture' },
    ],
  },
};

export function getCategoryMetadata(category: string): CategoryMetadata | undefined {
  return CATEGORY_METADATA[category];
}
